app.component('medicalMain', {
    templateUrl: 'app/medical/medical_main.html',
    controller: function ( $location, $timeout, sharedDataRegionService, medicalNormalRangeService, medicalUtil ) {
        var $ctrl = this;
        function _medicalDataInit() {
            $ctrl.medicalLogList = [];
            $ctrl.mEntryList = [];
            $ctrl.logData = {};
            $ctrl.logdataKey = {};
            $ctrl.medical_current_entry = "";
            $ctrl.medicalNormalRange = [];
            $ctrl.noDataFlg = true;
            var logDataList = medicalUtil.getMedicalDataList();
            if( logDataList.length > 0 ) {
                for ( var i = 0; i < logDataList.length; i++ ) {
                    $ctrl.medicalLogList[ logDataList[i].medicalEntry ] = logDataList[i];
                    $ctrl.mEntryList.push( logDataList[i].medicalEntry );
                }
                $ctrl.logdataKey = logDataList[ 0 ].medicalEntry
                $ctrl.logData = $ctrl.medicalLogList[ $ctrl.logdataKey ];
                $ctrl.medical_current_entry = $ctrl.logData.medicalEntry;
                //正常値判定
                angular.forEach($ctrl.logData, function (value, key) {
                    $ctrl.medicalNormalRange[key] = medicalNormalRangeService.medicalNormalRange( $ctrl.logData["medicalGender"], key, value );
                });
            }
            if( Object.keys($ctrl.medicalLogList).length > 0 ) {
                $ctrl.noDataFlg = false;
            }
        }
        $ctrl.$onInit = function () {
            $ctrl.nowDate = moment().format("YYYY-MM-DD 00:00:00");
            _medicalDataInit();
            $timeout(function() {
                $ctrl.menuSpeedDial = {
                    "isOpen" : false,
                    "selectedDirection" : "up",
                    "selectedMode" : "md-fling"
                };
                $ctrl.tooltip = {
                    "visible" : false,
                    "direction" : "left"
                }
            },0);
        };
        $ctrl.menuClick = function() {
            $timeout(function() {
                $ctrl.tooltip.visible = $ctrl.menuSpeedDial.isOpen;
            },500);
        }
        $ctrl.changeLogdatakey = function () {
            //対象の健診データ取得
            $ctrl.logData = $ctrl.medicalLogList[ $ctrl.logdataKey ];
            $ctrl.medical_current_entry = $ctrl.logData.medicalEntry;
            //正常値判定
            $ctrl.medicalNormalRange = [];
            angular.forEach( $ctrl.logData, function ( value, key ) {
                $ctrl.medicalNormalRange[ key ] = medicalNormalRangeService.medicalNormalRange( $ctrl.logData["medicalGender"], key, value );
            });
        }
        $ctrl.medical_add = function ( entry, mode ) {
            var mlist = medicalUtil.getMedicalDataByEntry( entry );
            var medicalId;
            if ( mlist != null ) {
                medicalId = mlist.medicalId;
            }
            else {
                medicalId = medicalUtil.createMedicalId();
            }
            $location.path("/medical_add/" + entry + "/" + medicalId +"/" + mode);
        }
        $ctrl.medical_del = function ( delentry ) {
            var result = confirm('この健診結果を削除しますが、よろしいですか？');
            if( result ) {
                // 削除実行
                if(  medicalUtil.delMedicalDataByEntry( delentry ) ) {
                    // 削除後のログデータ反映
                    _medicalDataInit();
                }
             }
        }
        $ctrl.go_diagnosis = function() {
            // 健診結果の対象データを共有領域へ退避
            sharedDataRegionService.setLogData( $ctrl.logData );
            // 健診結果画面へ遷移
            $location.path( "/medical_result" );
        }
    }
});
